module.exports = __webpack_public_path__ + "static/img/ball3.599ce76f.png";